module.exports = __webpack_public_path__ + "media/images/bus/add-ec6229f4a06f27c0d8ae38959161f5e8.svg";